import React from 'react';

const LoadingSpinner = ({ stroke = '' }) => (
  <svg
    className="loadingSpinner"
    width="32px"
    height="32px"
    viewBox="0 0 36 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs />
    <g
      // id="Page-6"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Artboard"
        transform="translate(-49.000000, -47.000000)"
        stroke={stroke || "#3174EE"}
        strokeWidth="4"
      >
        <polyline
          id="Page-1"
          points="51 64 51 81 83 81 83 72 61 72 73 58 51 58 51 49 83 49 83 66"
        />
      </g>
    </g>
  </svg>
);

export default LoadingSpinner;
